import script from "./Block.vue?vue&type=script&lang=ts&setup=true"
export * from "./Block.vue?vue&type=script&lang=ts&setup=true"

import "./Block.vue?vue&type=style&index=0&id=054841bc&lang=stylus&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-054841bc"]])

export default __exports__